module.exports = __webpack_public_path__ + "static/media/kimbu_jobs_logo.82aef040.png";